
import { defineComponent, PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'primevue/button';
import { WalletLegacySection } from '@/types/billing-types';

export default defineComponent({
  name: 'WalletLegacyPanel',

  components: { Button },

  props: {
    walletLegacy: {
      type: Object as PropType<WalletLegacySection>,
      required: true,
    },
  },

  emits: ['buy-credits'],

  setup() {
    const { t } = useI18n();
    const formatNumber = (n: number) => new Intl.NumberFormat('fr-FR').format(n);
    return { t, formatNumber };
  },
});
